import * as React from 'react'
import { clsx } from 'clsx'
import { PlateElement } from 'platejs/react'
import type { PlateElementProps } from 'platejs/react'

import styles from './ListElements.module.css'

const BulletedListElement = React.forwardRef<
  HTMLUListElement,
  PlateElementProps
>(({ children, className, ...props }, ref) => (
  <PlateElement
    {...props}
    ref={ref}
    as="ul"
    className={clsx(styles.list, className)}
  >
    {children}
  </PlateElement>
))

BulletedListElement.displayName = 'RichTextField.BulletedListElement'

const NumberedListElement = React.forwardRef<
  HTMLOListElement,
  PlateElementProps
>(({ children, className, ...props }, ref) => (
  <PlateElement
    {...props}
    ref={ref}
    as="ol"
    className={clsx(styles.list, className)}
  >
    {children}
  </PlateElement>
))

NumberedListElement.displayName = 'RichTextField.NumberedListElement'

const ListItemElement = React.forwardRef<HTMLLIElement, PlateElementProps>(
  ({ children, className, ...props }, ref) => (
    <PlateElement
      {...props}
      ref={ref}
      as="li"
      className={clsx(styles.item, className)}
    >
      {children}
    </PlateElement>
  ),
)

ListItemElement.displayName = 'RichTextField.ListItemElement'

const ListItemContentElement = React.forwardRef<
  HTMLDivElement,
  PlateElementProps
>(({ children, ...props }, ref) => (
  <PlateElement {...props} ref={ref} as="div">
    {children}
  </PlateElement>
))

ListItemContentElement.displayName = 'RichTextField.ListItemContentElement'

export {
  BulletedListElement,
  ListItemContentElement,
  ListItemElement,
  NumberedListElement,
}
